<template>
  <div class="menu-wrapper">
    <div class="navTop">
      <div class="logo">
        <img :src="logoUrl" />
        <div @click="openValidateIsShowListModal" class="switch" v-if="partnersChooseList.length > 1">
          <span>{{ $t('MENUSLIDE.qie-huan-qi-ye') }}</span>
        </div>
        <Modal v-model="showCompanyListModal" :width="400" title="请选择企业" footer-hide="">
          <div class="content">
            <div class="container">
              <Input search v-model="keyword" placeholder="请输入企业名称" clearable size="large" style="width: 100%" />
              <!-- 公司列表展示 -->
              <List :keyword="keyword" :list="partnersChooseList" :show="showCompanyListModal" @clearKeyword="keyword = ''" @select="clickChangeCompany" />
            </div>
          </div>
        </Modal>
      </div>
      <menu-wrapper :menuData="leftMenus" :infoData="bottomMenus" @clearUrl="url = ''" />
      <change-part-modal v-model="changePartValidVisible" :targetPartnerId="changeTargetPartnerId" :userInfo="userInfo" @success="changePartner"></change-part-modal>
    </div>
    <lang v-model="showLang" v-if="supportLang"></lang>

    <show-validate-modal v-model="showValidateVisible" :validateType="validateType" :title="$t('MENUSLIDE.qie-huan-qi-ye')" @success="openCompanyListModal"></show-validate-modal>
  </div>
</template>
<script>
import platform from '../../data/platform';
import login from '../../data/login';
import Lang from './lang.vue';
import MenuWrapper from './menuWrapper';
import { ElMessage } from 'element-plus/es/components/message';
import { Modal, Input } from 'view-ui-plus';

import ChangePartModal from '../modal/ChangePartModal.vue';
import ShowValidateModal from './showValidateModal.vue';
import List from './List.vue';

function isUAT() {
  return window.location.host.indexOf('-uat') != -1 || window.location.host.indexOf('-dev');
}

export default {
  components: { MenuWrapper, Lang, ChangePartModal, ShowValidateModal, List, Modal, Input },
  data() {
    return {
      keyword: '',
      showValidateVisible: false,
      validateType: '',
      showCompanyListModal: false,
      pollingInterval: null,
      downloadNumber: 0,
      runCount: 0,
      url: null,
      logoUrl: $ZConfig.getVal('LOGO'),
      userInfo: {},
      partners: [],
      leftMenus: [],
      otherMenus: {}, // 菜单权限
      bottomMenus: [], // 个人中心部分菜单栏
      topMenus: [],
      childrenMenu: {}, // 子菜单
      disableMenus: ['APPLY_BEFORE', 'reimbursement_settlement'], // 禁用的菜单：事前申请、报销
      personalCenter: 'personal_center', // 个人中心菜单编码
      personalMenu: {}, // 个人中心
      maxTds: 5, // 一行最多显示多少个
      curMenu: null, // 当前菜单
      curLang: {},
      showLang: false,
      supportLang: false,
      icons: {
        home: 'icon-home',
        TRAVEL_PLAN: 'icon-jihua',
        TRAVEL_BOOKING: 'icon-dingdan',
        personal_center: 'icon-geren'
      },
      timerA: null,
      timerB: null,
      localStorageValue: null,
      changePartValidVisible: false,
      changeTargetPartnerId: null,
      changeTargetId: null
    };
  },

  computed: {
    curPartnerName() {
      let curPartnerId = this.userInfo.partnerId;
      if (!curPartnerId || this.partners.length == 0) {
        return null;
      }
      let name = null;
      this.partners.forEach((partner) => {
        if (partner.partnerId == curPartnerId) {
          name = partner.partnerName;
          return false;
        }
      });
      return name;
    },
    partnersChooseList() {
      let rs = [];
      let curPartnerId = this.userInfo.partnerId;
      this.partners.forEach((partner) => {
        partner.checked = partner.partnerId === curPartnerId;
        rs.push(partner);
      });
      return rs;
    },
    langs() {
      return this.$store.state.langs;
    }
    // showPartnerName() {
    //   let curUrl = window.location.href
    //   return curUrl.includes('/vcommon/booking') || curUrl.includes('/vcommon/home') || curUrl.includes('/vcommon/plan/planIndex')
    // }
  },

  watch: {
    $route(nvl, ovl) {
      this.supportLang = nvl.meta.supportLang && this.$t;
      /*if(nvl.path!==ovl.path && ovl.path!=='/'){
          this.initTitle()
        }*/
    }
  },

  mounted() {
    // let fullPath = this.$route.fullPath
    // let i = fullPath.start('/vcommon/jsp')
    // if (i !== -1) {
    //   let origin = process.env.NODE_ENV === 'development' ? window.$ZConfig.getOrigin() : window.location.origin
    //   this.url = origin + fullPath.substr('/vcommon/jsp'.length)
    // }
    this.initLang();
    this.loadData();
    // this.startPolling()
    this.startTimerA();
  },

  methods: {
    async openValidateIsShowListModal() {
      // const res = await platform.verifyUserSecurity()
      const res = await platform.verifyGroupUserSecurity();
      const {
        data: { code, data }
      } = res;
      console.log('data ~ 🚀 ', data);
      const isNotVerify = data.some((item) => item.mobileVerify === '1');
      if (code == '0' && !isNotVerify) {
        const userInfo = await window.$ZConfig.getCurUserInfo();
        const { mobile } = userInfo;
        if (!mobile) {
          ElMessage.error({
            message: '本次操作需要手机验证，请先补充您的手机号'
          });
          return;
        }
        this.showValidateVisible = true;
        this.validateType = 'MOBILE';
      } else {
        this.showCompanyListModal = true;
      }
    },
    async openCompanyListModal(codeVal) {
      const res = await platform.verifyUserSecurityMobile(codeVal);
      const {
        data: { code, msg }
      } = res;
      if (code === '0') {
        this.showCompanyListModal = true;
      } else {
        ElMessage.error({
          message: msg || '验证码错误'
        });
      }
    },
    /**
     * 语言初始化
     */
    initLang() {
      this.supportLang = this.$route.meta.supportLang && this.$t;
      if (!this.supportLang) {
        return;
      }
      let lang = sessionStorage.getItem('_cur_lang') || window.navigator.language;
      let curLang = null;
      if (lang) {
        this.langs.forEach((l) => {
          if (l.lang == lang) {
            curLang = l;
            return false;
          }
        });
      }
      if (curLang) {
        this.curLang = curLang;
      } else {
        this.chooseLang(this.langs[0]);
      }
    },

    /**
     * 切换语言后刷新
     * @param lang
     */
    chooseLang(lang) {
      if (this.curLang && this.curLang.lang == lang.lang) {
        return;
      }
      this.curLang = lang;
      sessionStorage.setItem('_cur_lang', lang.lang);
      window.location.reload();
    },

    /**
     * 初始化
     */
    loadData() {
      platform.getInitData().then((res) => {
        // loading();
        if (res.data.code == '0') {
          this.initData(res.data.data);
          this.getDownloadNumber();
        } else {
          // this.$Message.error('初始化用户信息失败')
        }
      });
      platform.getPartnerList().then((res) => {
        const {
          data: { data }
        } = res;
        this.partners = data || [];
      });
    },

    /**
     * 转换数据
     */
    initData(data) {
      // let hostname = window.location.hostname
      this.userInfo = data.userInfo || {};
      // this.partners = data.partners || []
      // if (hostname.substr(0, hostname.indexOf('.')).includes('trip')) {
      //   this.companyLogo = 'https://tem-public.oss-cn-shanghai.aliyuncs.com/logo/mbcloud_com/index.png'
      // }
      // this.logoUrl = this.userInfo.logoUrl || this.companyLogo
      let curPath = this.$route.path;

      let menus = data.menus || [];
      let menuPidMap = {};

      let parentMenus = [];
      menus.forEach((menu) => {
        if (!menu.pid) {
          parentMenus.push(menu);
        } else {
          let children = menuPidMap[menu.pid];
          if (children) {
            children.push(menu);
          } else {
            menuPidMap[menu.pid] = [menu];
          }
        }
        // 注意配置菜单时需要以/开头
        let url = this.getMenuUrl(menu);
        if (url == curPath) {
          this.curMenu = menu;
        }
      });

      // 左侧菜单：pid = null, def != nul
      let leftMenus = [];
      // 顶部菜单: pid = null,def == null && children.length > 0
      let topMenus = [];
      parentMenus.forEach((m) => {
        if (this.disableMenus.indexOf(m.code) !== -1) {
          return;
        }
        if (m.code === this.personalCenter) {
          this.personalMenu = m;
          return;
        }
        if (m.def) {
          leftMenus.push(m);
        } else if (menuPidMap[m.id]) {
          topMenus.push(m);
        }
      });

      // 排序
      this.sortMenu(leftMenus);
      this.sortMenu(topMenus);
      for (let k in menuPidMap) {
        this.sortMenu(menuPidMap[k]);
      }

      this.topMenus = topMenus;
      this.childrenMenu = menuPidMap;

      // 把左侧上面菜单栏子数据推进去
      this.normalizeMenu(topMenus);
      // 暂时写死 后面后端配置
      let moreMenu = {
        appendix: '',
        code: 'icon-more',
        data: [
          {
            name: this.$t('MENUSLIDE.ding-dan'),
            url: '/common/pcOrderList/index',
            code: 'order',
            icon: 'icon-dingdan'
          },
          {
            name: this.$t('MENUSLIDE.shen-pi'),
            url: '/v/notify/message/loadUnDoTask.html',
            id: 'Approve',
            code: 'Approve',
            icon: 'icon-shenpi1'
          }
        ],
        def: '',
        icon: 'icon-more',
        id: null,
        name: this.$t('MENUSLIDE.geng-duo'),
        openMode: 0,
        orgSelect: -1,
        pid: null,
        sceneId: 'TEM_WEB',
        seq: null,
        status: 0,
        sysId: 'OTA',
        trans: null,
        type: 'more'
      };
      this.otherMenus = data.otherMenus || {};
      // if (data.otherMenus && data.otherMenus.moreEnable) {
      this.topMenus.push(moreMenu);
      // }
      // 合并
      this.leftMenus = leftMenus.concat(this.topMenus);
      // 个人中心菜单栏
      this.updateMenus();
      this.initTitle();
    },

    startTimerA() {
      // 每 30 秒检查一次 localStorage
      this.timerA = setInterval(() => {
        const value = localStorage.getItem('liqDownloadValue');
        if (value) {
          // 如果找到了值，清除定时器 A 并开始 10 分钟倒计时
          clearInterval(this.timerA);
          this.timerA = null;
          this.localStorageValue = value;
          this.startTimerB();
        }
      }, 30000);
    },

    startTimerB() {
      // 10 分钟倒计时，每 30 秒检查一次
      const tenMinutes = 10 * 60 * 1000;
      let countdown = tenMinutes;
      this.timerB = setInterval(async () => {
        countdown -= 30000;
        if (countdown <= 0) {
          // 如果超过了 10 分钟，清除定时器 B 和 localStorage 值
          clearInterval(this.timerB);
          this.timerB = null;
          localStorage.removeItem('liqDownloadValue');
          this.localStorageValue = null;
        } else {
          try {
            const response = await platform.getDownloadNumber();
            if (response.data.code == '0') {
              this.runCount = response.data.data.runCount;
              this.downloadNumber = response.data.data.runCount + response.data.data.successCount;
              if (this.downloadNumber > 99) {
                this.downloadNumber = '99+';
              }
              // 个人中心菜单栏
              let bottomMenus = [
                { name: '', code: 'download', id: null, downloadNumber: this.downloadNumber, runCount: this.runCount, disabled: false },
                { name: '', code: 'icon-xiaoxi', id: null, disabled: false },
                { name: '', code: 'locale', id: null, disabled: window.$ZConfig.getVal('PC_EN') !== '1' || window.$ZConfig.getVal('I18N_ENABLE') !== true }, // 暂时关闭国际化，后面再打开
                { name: '', code: 'icon-geren', id: this.personalMenu.id, disabled: false }
              ].filter((item) => !item.disabled);
              this.normalizeMenu(bottomMenus);
              this.bottomMenus = bottomMenus;
            }
          } catch (error) {
            console.log(error);
          }
        }
      }, 30000);
    },

    // 初始化轮询
    async startPolling() {
      try {
        const response = await platform.getDownloadNumber();
        if (response.data.code == '0') {
          this.runCount = response.data.data.runCount;
          this.downloadNumber = response.data.data.runCount + response.data.data.successCount;
          if (this.downloadNumber > 99) {
            this.downloadNumber = '99+';
          }
        }
        // 轮询间隔，可以根据需求进行调整
        // uat设置轮训时间* 6
        this.pollingInterval = setInterval(this.getDownloadNumber, isUAT() ? 1000 * 60 : 30000); // 10秒后再次发送请求
      } catch (error) {
        console.log(error);
      }
    },

    // 更新底部菜单
    updateMenus() {
      let bottomMenus = [];
      if (this.otherMenus) {
        if (this.otherMenus.downloadCenter) {
          bottomMenus.push({ name: '', code: 'download', id: null, downloadNumber: this.downloadNumber, runCount: this.runCount });
        }
        if (this.otherMenus.messageEnable) {
          bottomMenus.push({ name: '', code: 'icon-xiaoxi', id: null });
        }
      }
      // 暂时关闭国际化，后面再打开
      if (window.$ZConfig.getVal('PC_EN') === '1' && window.$ZConfig.getVal('I18N_ENABLE') === true) {
        bottomMenus.push({ name: '', code: 'locale', id: null });
      }
      bottomMenus.push({ name: '', code: 'icon-geren', id: this.personalMenu.id });
      this.normalizeMenu(bottomMenus);
      this.bottomMenus = bottomMenus;
    },

    // 统计用户下载次数
    async getDownloadNumber() {
      try {
        const response = await platform.getDownloadNumber();
        if (response.data.code == '0') {
          this.runCount = response.data.data.runCount;
          this.downloadNumber = response.data.data.runCount + response.data.data.successCount;
          if (this.downloadNumber > 99) {
            this.downloadNumber = '99+';
          }
          this.updateMenus();
        }
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * 转换左边菜单栏数据
     */
    normalizeMenu(arr = []) {
      if (!arr.length) return;

      arr.forEach((item) => {
        if (item.id) {
          let data = this.getChildren(item.id);
          let rs = [];
          if (data.length) {
            data.forEach((arrItem) => {
              if (arrItem.length) {
                arrItem.forEach((obj) => {
                  obj.list = this.childrenMenu[obj.id];
                  rs.push(obj);
                });
              }
            });
          }
          item.data = rs;
        }
      });
    },

    /**
     * 排序
     */
    sortMenu(menus) {
      menus.sort(function (a, b) {
        return (a.seq || 0) - (b.seq || 0);
      });
    },

    /**
     * 初始化标题
     */
    initTitle() {
      let title = this.userInfo.partnerName || '';
      let meta = this.$route.meta;
      if (meta && meta.title) {
        title += '-' + meta.title;
      } else if (this.curMenu) {
        title += '-' + this.curMenu.name;
      }
      document.title = title;
    },
    clickChangeCompany(item) {
      this.showCompanyListModal = false;
      this.changePartnerModal(item);
    },
    // 打开企业弹窗
    async changePartnerModal(item = {}) {
      if (item.checked) return;
      const res = await platform.verifyRequiredFlag({ targetPartnerId: item.partnerId });
      const {
        data: { code, data }
      } = res;
      if (code == 0 && data) {
        this.changePartValidVisible = true;
        this.changeTargetPartnerId = item.partnerId;
        this.changeTargetId = item.id;
      } else {
        this.changeCompany(item.id);
      }
    },
    /**
     * 切换企业
     * @param item
     * @returns {Promise<void>}
     */
    changePartner(pcAutoLoginUrl) {
      localStorage.clear();
      window.$jump.goLocPage(pcAutoLoginUrl);
    },

    /**
     * 切换企业接口
     */
    async changeCompany(id) {
      /*this.$w.loading.show({
          text: '正在切换..'
        })*/

      let res = await login.changeUser(id);
      if (res.code === '0') {
        ElMessage.success({
          message: '企业切换成功！'
        });
        location.pathname = '/v/vcommon/home';
      } else {
        ElMessage.error({
          message: res.msg || '切换企业失败!'
        });
      }
    },

    getChildren(id) {
      if (!id) {
        return [];
      }
      let maxTds = this.maxTds;
      let children = this.childrenMenu[id] || [];
      if (children.length <= maxTds) {
        return [children];
      }
      let i = 0;
      let rs = [];
      while (true) {
        let left = children.length - i;
        if (left < 1) {
          break;
        }
        if (left > maxTds) {
          rs.push(children.slice(i, i + maxTds));
          i += maxTds;
        } else {
          let lastTds = children.slice(i, i + left);
          // 填充数量保证td不缺
          for (let j = 0; j < maxTds - left; j++) {
            lastTds.push([]);
          }
          rs.push(lastTds);
          break;
        }
      }
      return rs;
    },

    getMenuUrl(menu) {
      return menu.trans ? menu.trans.def : menu.def;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.menu-wrapper {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;

  .lang {
    cursor: pointer;
    margin-right: 8px;

    .icon-svg-show {
      width: 28px;
      height: 28px;
      vertical-align: -7px;
    }

    .ivu-dropdown-item {
      display: flex;
      align-items: center;

      .icon-svg {
        width: 2em;
        height: 2em;
        line-height: 2em;
      }
    }
  }

  .home-content {
    flex: 1;
    width: 100%;
    height: 100%;
    padding: 20px;
    overflow-x: auto;
    overflow-y: visible;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .home-content::-webkit-scrollbar {
    display: none;
  }
  .home-content-pd {
    padding-top: 80px;
  }
  .curPartnerName {
    position: fixed;
    z-index: 8;
    top: 0;
    left: 100px;
    padding-left: 20px;
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    color: #333;
    font-size: 18px;
    font-weight: 600;
    background-color: #fff;
  }
}

.navTop {
  display: flex;
  padding: 0 14px;
  flex-direction: column;
  flex: 0 0 100px;
  color: #ffffff;
  font-size: 14px;
  background-color: #495060;

  .logo:hover .logo-popup {
    // display: block;
  }
  .logo {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    flex: 0 0 110px;
    height: 110px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    > img {
      width: 60%;
      max-width: 78px;
      max-height: 78px;
      min-width: 62px;
      min-height: 62px;
    }
    .switch {
      display: flex;
      align-items: center;
      margin-top: 10px;
      padding: 8px 6px;
      font-size: 14px;
      font-weight: 600;
      border-radius: 8px;
      background-color: #3e4452;
      i {
        font-size: 12px;
      }
    }
    .logo-popup:hover {
      display: block;
    }
    .logo-popup {
      position: absolute;
      // display: none;
      top: 10px;
      left: 68px;
      z-index: 9;
      cursor: pointer;
      .logo-content {
        display: flex;
      }
      .transparent-box {
        width: 32px;
        min-height: 120px;
        background-color: transparent;
      }
      .logo-list {
        padding: 12px 10px;
        min-height: 100px;
        background-color: #495060;
        border-radius: 8px;
        box-sizing: border-box;
        .title {
          margin: 0 0 8px 8px;
          font-size: 12px;
          color: rgba(255, 255, 255, 0.65);
        }
        .logo-item {
          min-width: 250px;
          max-width: 332px;
          padding: 8px;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-between;
          min-height: 50px;
          font-size: 14px;
          color: #fff;
          border-radius: 8px;
          .left {
            width: 90%;
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
          }
          img {
            margin-right: 8px;
            width: 20px;
            height: auto;
          }
          .icon-wrapper {
            display: flex;
            align-items: center;
            justify-content: flex-end;
          }
        }
        .logo-item:hover {
          background-color: #3e4452;
        }
      }
    }
  }
  @media (max-height: 716px) {
    .logo {
      flex: 0 0 70px;
      height: 70px;
      img {
        height: 24px;
        width: auto;
      }
      .switch span {
        font-size: 12px;
      }
    }
  }

  i {
    display: block;
    margin-right: 0;
  }

  .iconfont {
    font-size: 25px;
  }

  .icon-home {
    color: #ffffff;
  }
}
</style>
